import { useState } from "react";
import { Box } from "../../../common/components";
import Avatar from "../../../common/components/Avatar/Avatar";
import { createStyles, palette } from "../../../styles/theme";
import InviteTeammateModal from "../../InviteTeammateModal/InviteTeammateModal";
import { ROUTES } from "../../../constant/common.constant";
import { generatePath, useNavigate } from "react-router-dom";
import { useCollaborators } from "../../../context/Collaborators/useCollaborators";
import { useStudio } from "../../../context/Studio";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTeam } from "../../../context/Team";

const styles = createStyles({
  container: {
    display: "flex",
    justifyContent: "flex-end",
    minWidth: "172px",
    maxWidth: "172px",
  },

  avatarContainer: {
    ml: "-6px",
    borderRadius: "50%",
  },
});

interface Props {
  teamId?: string;
}

const MAX_AVATAR_DISPLAY_NUMBER = 5;

const ActiveUserList = ({ teamId }: Props) => {
  const [inviteOpen, setInviteOpen] = useState(false);
  const { t } = useTranslation();
  const { activeCollaborators } = useCollaborators();
  const navigate = useNavigate();
  const { editorConfig } = useStudio();
  const isMaximumReached =
    activeCollaborators.length > MAX_AVATAR_DISPLAY_NUMBER;
  const { team } = useTeam();

  const toggleInviteModal = () => setInviteOpen((prev) => !prev);

  return (
    <>
      <Box sx={styles.container}>
        {(isMaximumReached
          ? activeCollaborators.slice(0, MAX_AVATAR_DISPLAY_NUMBER)
          : activeCollaborators
        )
          .filter((a) => a.designId)
          .map((a, index) => (
            <Box sx={styles.avatarContainer} key={index}>
              {isMaximumReached && index >= MAX_AVATAR_DISPLAY_NUMBER - 1 ? (
                <Avatar
                  initials={`+${activeCollaborators.length - MAX_AVATAR_DISPLAY_NUMBER}`.toString()}
                  color={palette.brand.secondary}
                />
              ) : (
                <Avatar
                  {...a}
                  onClick={() =>
                    navigate(
                      generatePath(ROUTES.STUDIO, {
                        designId: a.designId,
                        projectId: a.projectId,
                        teamId: a.teamId,
                      })
                    )
                  }
                />
              )}
            </Box>
          ))}
        {!editorConfig?.toolbar?.hideInviteUserButton && (
          <Tooltip title={t("studio.toolbar.invite_collaborators")}>
            <Box
              sx={{
                ...styles.avatarContainer,
                cursor: "pointer",
                "&>div": {
                  cursor: "pointer",
                  padding: "4px",
                  border: "none",
                },
              }}
              onClick={toggleInviteModal}
            >
              <Avatar icon="person_add" color={palette.grey.lightGrey} />
            </Box>
          </Tooltip>
        )}
      </Box>
      <InviteTeammateModal
        open={inviteOpen}
        onClose={toggleInviteModal}
        teamId={teamId}
        projects={team?.projects}
      />
    </>
  );
};

export default ActiveUserList;
